// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cfOrdinate1{width:7.3vw}.cfOrdinate1,.cfOrdinate2{font-size:.83333vw;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.cfOrdinate2{width:4vw}", ""]);
// Exports
module.exports = exports;
